import {createReducer} from '@reduxjs/toolkit';
import {
    getAllEventFamiliesSuccess,
    removeEventFamilyByNameSuccess,
} from 'src/openapi/apis/EventFamilyControllerApi';
import {EventFamilyInfo} from 'src/openapi/models/EventFamilyInfo';

type State = {
    data: EventFamilyInfo[],
    isLoaded: boolean,
};

const defaultState: State = {
    data: [],
    isLoaded: false,
};

export const eventFamilies = createReducer<State>(defaultState, builder => builder
    .addCase(getAllEventFamiliesSuccess, (state, action) => {
        state.data = action.payload.data;
        state.isLoaded = true;
    })
    .addCase(removeEventFamilyByNameSuccess, (state, action) => {
        state.data = state.data.filter(family => family.name !== action.payload.meta.name);
    }),
);
